import { Header4, InlineText2, Paragraph2, TooltipDesktop } from '@cian/ui-kit';
import React from 'react';

import { IVas } from '../../types/vas';
import { ContentRow } from '../ContentRow';
import { VasIcon } from './VasIcon';
import styles from './VasList.css';

interface IVasListProps {
  items: IVas[];
  bet?: string | number;
  liquidityPoints: number | null;
  nextBetTip?: React.ReactNode;
}

export function VasList({ items, bet, liquidityPoints, nextBetTip }: IVasListProps) {
  return (
    <div className={styles['cont']}>
      <TooltipDesktop
        theme="white"
        placement="top-end"
        title={
          <>
            <ContentRow size="M">
              <Header4>К объявлению применены опции: </Header4>
            </ContentRow>
            {items.map(vas => (
              <ContentRow size="M" key={`vas-${vas.type}`}>
                <div className={styles['row']}>
                  <VasIcon type={vas.type} />
                  <InlineText2 fontWeight="bold">{vas.name}</InlineText2>
                </div>
                <Paragraph2>{vas.description}</Paragraph2>
              </ContentRow>
            ))}
            <div className={styles['button']}>
              <a href="https://www.cian.ru/promo/adv/" target="_blank" rel="noreferrer">
                Узнать подробнее
              </a>
            </div>
          </>
        }
      >
        <div className={styles['inner']}>
          {items.map(vas => (
            <div data-vas={vas.type} className={styles['icon']} key={`vas-icon-${vas.type}`}>
              <VasIcon type={vas.type} />
            </div>
          ))}
          {liquidityPoints && <div className={styles['liquidity-points']}>+&nbsp;{liquidityPoints}₽ от Циан</div>}
          {!liquidityPoints && bet && <div className={styles['bet']}>{bet}&nbsp;₽</div>}
          {nextBetTip && <div className={styles['tip']}>{nextBetTip}</div>}
        </div>
      </TooltipDesktop>
    </div>
  );
}
